export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/info-circle-blue.ff0cde64.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};